import script from "./GameInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./GameInfo.vue?vue&type=script&setup=true&lang=ts"

import "./GameInfo.vue?vue&type=style&index=0&id=1a4eda49&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a4eda49"]])

export default __exports__